import http from '../config/http';
import routes from '../config/api_routes';

export const all = (props = {}) => {
    props.complete = true;
    props.pagesize = 100;
    props.page= 1;
    props.paged = true;
    return http().get(routes.users.all, {
        params: props
    });
}

export const myUser = (props = {}) => {
    return http().get(routes.users.myUser, { params: props });
}

export const excluirConta = data => http().put(routes.users.deleteMyUser, data);

export const getNewTerms = data => http().get(routes.users.getNewTerms, data);

export const updateNewTerms = data => http().put(routes.users.updateNewTerms, data);

export const updateMyUser = data => http().put(routes.users.updateUser, data);

export const recoverPassword = data => http().put(routes.users.recoverPassword, data);

export const removeImage = (userId, remove = false) => {
    return new Promise((resolve) => {
        if(!remove) {
            resolve();
        } else {
            resolve(http().delete((routes.users.deleteImage||'').replace(':id', userId)));
        }
    })
    
}

export const save = (data, id = null, admin = true) => {
    if(!id) {
        return http().post(admin ? routes.users.addUser : routes.users.all, data);
    } else {
        var route = (routes.users.byId||'').replace(':id', id);
        return http().put(route, data);
    }
}

export const updatePassword = (data) => {
    return http().put(routes.users.updatePassword, data);
}

